<template>
  <div class="richtext-social-record">
    <a
      v-for="item in data.socialMediaLinks"
      :key="item.id"
      :aria-label="item.linkText"
      class="link"
      :href="item.link"
      target="_blank"
      rel="noreferrer"
    >
      <span class="text">{{ item.linkText }}</span>
      <span class="icon" :style="{ backgroundImage: `url(${item.logo.url})` }"></span>
    </a>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  data: {
    socialMediaLinks: {
      id: string;
      link: string;
      linkText: string;
      logo: {
        url: string;
      };
    }[];
  };
}>();
</script>

<style scoped lang="scss">
.richtext-social-record {
  padding: 2.5rem 0;
  display: flex;
  gap: 1.5rem;

  > .link {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    border: none;
    text-decoration: none;
    background: none;
    opacity: 1;
    transition: opacity 300ms;

    &:hover {
      opacity: 0.8;
    }

    > .text {
      position: absolute;
      z-index: -100;
      font-size: 0;
    }

    > .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
